export default __webpack_public_path__ + "static/media/sauced_vanilla_gelato.762ff0e5.png";